import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import GetAppIcon from "@material-ui/icons/GetApp";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { DataGrid } from '@mui/x-data-grid';
import SnackbarAlert from "../components/SnackbarAlert";
import { gestionArchivosResources, clientesResources} from "../endpoints";
import { withRouter } from "react-router";
import useToken from "../useToken";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";

class GestionArchivos extends React.Component {
    constructor(props) {
        let datos_user = useToken.getUser();
        super(props);
        this.state = {
        archivos: [],
        clientes: [],
        selectedClient: "",
        selectedFile: null,
        loading: false,
        pageSize: 10,
        openSnack: false,
        severity: null,
        message: null,
        esAdminUOficina: datos_user?.perfil === "admin" || datos_user?.perfil === "oficina SCA",
        };
    }

    componentDidMount() {
        if (this.state.esAdminUOficina) {
            this.obtenerClientes();
        }
        this.obtenerArchivos();
    }

    showSnackbar = (message, severity) => {
        this.setState({ openSnack: false }, ()=>{
            this.setState({
                openSnack: true,
                message: message,
                severity: severity,});
        });
    };

    obtenerArchivos = () => {
        gestionArchivosResources.getArchivos().then(async (response) => {
            if (response) {
            const result = await response.json();
            if (response.ok) {
                this.setState({ archivos: result });
            } else {
                this.showSnackbar(
                result.detail || "Error al obtener archivos",
                "error"
                );
            }
            }
        })
        .catch((error) => {
            console.error(error);
            this.showSnackbar("Error al conectar con el servidor", "error");
        });
    };

    obtenerClientes = () =>{
        clientesResources.getClientes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(data => {
            this.setState({clientes:data})
        }).catch(error=> {
            console.error(error);
        });
    }

    handleFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    };

    handleClientChange = (event) => {
        const clientId = event.target.value;
        this.setState({ selectedClient: clientId });
        this.obtenerArchivos(clientId);
    };

    handleUpload = (e) => {
        e.preventDefault();
        // Corregido: usamos esAdminUOficina que es como está definido en tu this.state
        const { selectedFile, selectedClient, esAdminUOficina } = this.state;

        if (esAdminUOficina && !selectedClient) {
        this.showSnackbar("Debe seleccionar un cliente antes de subir el archivo", "warning");
        return;
        }

        if (!selectedFile) {
        this.showSnackbar("Debe seleccionar un archivo primero", "warning");
        return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        
        // Se envía el id del cliente seleccionado en el dropdown
        if (selectedClient) {
        formData.append("client_id", selectedClient);
        }

        this.setState({ loading: true });

        gestionArchivosResources.subirArchivo(formData).then(async (response) => {
            const result = await response.json();
            if (response.ok) {
            this.showSnackbar("Archivo subido de forma correcta", "success");
            this.setState({ selectedFile: null });
            const fileInput = document.getElementById("file-input");
            if (fileInput) fileInput.value = "";
            
            // Al recargar, obtenerArchivos no recibe nada para mostrar la lista completa
            this.obtenerArchivos();
            } else {
            const msg = result.detail || result.message || "Error al subir archivo";
            this.showSnackbar(msg, "error");
            }
        })
        .catch((error) => {
            console.error(error);
            this.showSnackbar("Error crítico al subir el archivo", "error");
        })
        .finally(() => {
            this.setState({ loading: false });
        });
    };

    handleDownload = (row) => {
        gestionArchivosResources.descargarArchivo(row.id).then(async (response) => {
            if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = row.filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            this.showSnackbar("Descarga iniciada", "warning");
            } else {
            const result = await response.json();
            this.showSnackbar(
                result.detail || "Error al descargar el archivo",
                "error"
            );
            }
        })
        .catch((error) => {
            console.error(error);
            this.showSnackbar("Error al procesar la descarga", "error");
        });
    };

    handleDelete = (row) => {
        gestionArchivosResources.eliminarArchivo(row.id).then(async (response) => {
            const result = await response.json();
            if (response.ok) {
            this.showSnackbar(
                result.message || "Archivo eliminado de forma correcta",
                result.severity || "success"
            );
            this.obtenerArchivos();
            } else {
            const msg = result.detail || result.message || "Error al eliminar archivo";
            this.showSnackbar(msg, "error");
            }
        })
        .catch((error) => {
            console.error(error);
            this.showSnackbar("Error al eliminar el archivo", "error");
        });
    };

    getColumns = () => {
        const columns = [];

        // 1. Si es Admin u Oficina SCA, insertamos la columna ID Cliente al inicio
        if (this.state.esAdminUOficina) {
            columns.push({
                field: "name_client",
                headerName: "Carpeta",
                minWidth: 200,
                valueGetter: (params) => params.row.client_id + "_" + params.row.name_client.replace(" ", "_"),
            });
        }

        // 2. Agregamos las columnas estándar
        columns.push(
            { field: "filename", headerName: "Nombre de Archivo", flex: 1, minWidth: 200 },
            {
                field: "size_bytes",
                headerName: "Tamaño (KB)",
                width: 130,
                valueGetter: (params) =>
                (params.row.size_bytes / 1024).toFixed(2) + " KB",
            },
            {
                field: "created_at",
                headerName: "Fecha Carga",
                width: 200,
                valueGetter: (params) =>
                new Date(params.row.created_at).toLocaleString(),
            },
            { field: "name_uploaded_by", headerName: "Subido por", minWidth: 300 },
            {
                field: "acciones",
                headerName: "Acciones",
                width: 120,
                sortable: false,
                filterable: false,
                renderCell: (params) => (
                <div>
                    <Tooltip title="Descargar Archivo">
                    <IconButton
                        size="small"
                        onClick={() => this.handleDownload(params.row)}
                    >
                        <GetAppIcon />
                    </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar Archivo">
                    <IconButton
                        size="small"
                        style={{ color: "#f44336" }}
                        onClick={() => this.handleDelete(params.row)}
                    >
                        <DeleteIcon />
                    </IconButton>
                    </Tooltip>
                </div>
                ),
            }
        );

        return columns;
    };

    render() {
        return (
        <div>
            <Typography variant="h4" gutterBottom>
                    Gestión Archivos
            </Typography>
            <Paper style={{ padding: 24, marginBottom: 24, borderRadius: 8 }} elevation={2}>
                <Typography variant="h6" gutterBottom style={{ color: "#333", fontWeight: 600 }}>
                    Cargar Archivos
                </Typography>
                <Divider style={{ marginBottom: 20 }} />

                <form onSubmit={this.handleUpload}>
                    <Grid container spacing={3} alignItems="center">
                        {this.state.esAdminUOficina && (
                            <Grid item xs={12} sm={4}>
                                <FormControl variant="outlined" fullWidth size="small">
                                    <InputLabel id="select-cliente-label">Seleccionar Cliente *</InputLabel>
                                    <Select
                                        labelId="select-cliente-label"
                                        value={this.state.selectedClient}
                                        onChange={this.handleClientChange}
                                        label="Seleccionar Cliente *"
                                    >
                                        <MenuItem value="">
                                            <em>Todos los clientes</em>
                                        </MenuItem>
                                        {this.state.clientes.map((c) => (
                                            <MenuItem key={c.id} value={c.id}>
                                                {c.descripcion}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        <Grid item xs={6} sm={this.state.esAdminUOficina ? 5 : 8}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <input
                                        id="file-input"
                                        type="file"
                                        onChange={this.handleFileChange}
                                        style={{ display: "none" }}
                                    />
                                    <label htmlFor="file-input">
                                        <Button variant="contained" component="span">
                                            Seleccionar Archivo
                                        </Button>
                                    </label>
                                </Grid>
                                <Grid item xs>
                                    <Typography variant="body2" style={{ color: "#555", fontStyle: this.state.selectedFile ? "normal" : "italic" }}>
                                        {this.state.selectedFile
                                            ? this.state.selectedFile.name
                                            : "Ningún archivo seleccionado"}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6} sm={3} style={{ textAlign: "right" }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={<CloudUploadIcon />}
                                disabled={!this.state.selectedFile || this.state.loading}
                                fullWidth
                            >
                                {this.state.loading ? "Subiendo..." : "Subir Archivo"}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Paper style={{ padding: 24, borderRadius: 8 }} elevation={2}>
                <Typography variant="h6" gutterBottom style={{ color: "#333", fontWeight: 600 }}>
                    Archivos Disponibles
                </Typography>
                <Divider style={{ marginBottom: 20 }} />

                <div style={{ height: 480, width: "100%" }}>
                    <DataGrid
                        rows={this.state.archivos}
                        columns={this.getColumns()}
                        pageSize={this.state.pageSize}
                        onPageSizeChange={(newPageSize) =>
                            this.setState({ pageSize: newPageSize })
                        }
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        disableSelectionOnClick
                        density="compact"
                    />
                </div>
            </Paper>

            {/* Notificaciones globales */}
            {this.state.openSnack ? (
                <SnackbarAlert
                    severity={this.state.severity}
                    message={this.state.message}
                />
            ) : null}
        </div>
        );
    }
}

export default withRouter(GestionArchivos);